import React from 'react';
import { cn } from '@bem-react/classname';
import './ListTile.css';
export var cnListTile = cn('ListTile');
var cnListTileLeading = cnListTile('Leading');
var cnListTileTrailing = cnListTile('Trailing');
/**
 * Блок примитив для удобного позиционирования контента, обрамлённый иконками или другими блоками например checkbox
 *
 * @param { ListTileProps }  props
 */
export var ListTile = function (_a) {
    var children = _a.children, leading = _a.leading, trailing = _a.trailing, className = _a.className, inline = _a.inline, alignItems = _a.alignItems, leftSpace = _a.leftSpace, rightSpace = _a.rightSpace, onClick = _a.onClick;
    return (React.createElement("div", { onClick: onClick, className: cnListTile({
            inline: inline,
            alignItems: alignItems,
        }, [className]) },
        leading && React.createElement("div", { className: cnListTileLeading }, leading),
        React.createElement("div", { className: cnListTile('Wrapper', {
                leftSpace: leftSpace,
                rightSpace: rightSpace,
            }) }, children),
        trailing && React.createElement("div", { className: cnListTileTrailing }, trailing)));
};
ListTile.displayName = cnListTile();
